export default __webpack_public_path__ + "static/media/AiGateway.699fd1f5.svg";